<template>
<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.75 2.25H4.25C3.42157 2.25 2.75 2.92157 2.75 3.75V14.25C2.75 15.0784 3.42157 15.75 4.25 15.75H14.75C15.5784 15.75 16.25 15.0784 16.25 14.25V3.75C16.25 2.92157 15.5784 2.25 14.75 2.25Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.5 6V12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.5 9H12.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
